/**
 * Logical depth limit for the registry schema field selector form
 */
export const ENTITY_SCHEMA_FIELD_SELECTOR_LOGICAL_DEPTH_LIMIT = 4;

/**
 * Subtract one from the overall limit because backlink (result-join) fields are one level deep into the
 * query.
 */
export const RESULT_SCHEMA_FIELD_SELECTOR_LOGICAL_DEPTH_LIMIT =
  ENTITY_SCHEMA_FIELD_SELECTOR_LOGICAL_DEPTH_LIMIT - 1;
